<template>
    <div style="height: 100%;">
        <el-form :inline="true"  :model="param" class="demo-form-inline">
            <el-form-item label="卡号">
                <el-input v-model="param.cardnumber" size="mini" style="width: 100px;" @change="changeQuery"></el-input>
            </el-form-item>
            <el-form-item label="日期">
                <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100px"
                                        v-model="param.accountdate" name="birthday"
                                        type="date"
                                        placeholder="选择日期" @change="changeQuery">
                        </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" style="width: 100%;" :loading="queryLoadBtton" size="mini" @click="openAddCard">开卡</el-button>
            </el-form-item>
        </el-form>
        <el-table height="calc(100% - 2rem)"  border :data="queryCardOperation" size="mini" style="text-align: center" highlight-current-row v-loadmore="getCardOperationByParam">
            <el-table-column label="合作门店" align="center"prop="hzstorename"></el-table-column>
            <el-table-column label="会员卡号" align="center"prop="cardnumber"></el-table-column>
            <el-table-column label="顾客姓名" align="center"prop="membername"></el-table-column>
            <el-table-column label="账务日期" align="center"prop="accountdate">
                <template slot-scope="scope">
                    {{$moment(scope.row.accountdate).format('YYYY-MM-DD')}}
                </template>
            </el-table-column>
        </el-table>
    
    <el-dialog title="会员开卡" :visible.sync="dialogVisible" width="100%" top="0px" :fullscreen="true" :before-close="handleClose">
    <div style="padding: 5px;">
        <el-form ref="form" :model="addCardOperation" label-width="80px" size="mini" :rules="rules">
            <el-form-item label="会员卡号" prop="cardnumber"> 
                <el-input v-model="addCardOperation.cardnumber" readonly size="mini" @change="getCardInfoByCardNumberUnsold"></el-input>
            </el-form-item>
            <el-form-item label="会员姓名" prop="membername">
                <el-input v-model="addCardOperation.membername" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="addCardOperation.sex" name="sex">
                    <el-radio-button :label="1">男</el-radio-button>
                    <el-radio-button :label="2">女</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号码" prop="memberphone" v-show="false">
                <el-input v-model="addCardOperation.memberphone" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="客户归属" prop="hzstoreid">
                <el-select v-model="addCardOperation.hzstoreid" placeholder="请选择" style="width: 100%;" filterable>
                    <el-option v-for="item in stores" :key="item.storeid" :label="item.storename" :value="item.storeid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="负责人" prop="headstaffid">
                <el-select v-model="addCardOperation.headstaffid" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in staffInfos" :key="item.staffid" :label="item.staffname" :value="item.staffid">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" :loading="queryLoadBtton" @click="saveOpenCard">保存</el-button>
    </div>
    </el-dialog>
</div>
</template>
<script>
    export default {
        data() {
            return {
                ismore:true,
                queryCardOperation:[],
                param:{

                },
                curpage:1,
                pagesize:20,
                dialogVisible:false,
                queryLoadBtton:false,
                stores:[],
                staffInfos:[],
                storeid:localStorage.getItem("storeid"),
                addCardOperation:{},
                cardoperation:{
                    headstaffid:localStorage.getItem("staffid"),
                    hzstoreid:"",
                    isadd:false,
                    storeid:"",
                    sysbillid:"",
                    billtype:1,
                    cardgstoreid:"",
                    cardid:"",
                    cardtypeid:"f24740c985fb473e8a6908c0317f8545",
                    cardtypename:"",
                    cardnumber:"",
                    membername:"",
                    membersource:[],
                    membersource1:"",
                    membersource2:"",
                    sex:"",
                    memberphone:"12345678901",
                    birthday:"",
                    cid:"",
                    openamount:0,
                    rechangeamount:0,
                    storearrears:0,
                    coursearrears:0,
                    amount:0,
                    beforebalance:0,
                    oldgstoreid:"",
                    oldcardid:"",
                    oldcardtypeid:"",
                    oldcardnumber:"",
                    oldmembername:"",
                    oldsex:null,
                    oldbalance:0,
                    paystatus:1,
                    accountdate:this.$moment().format('YYYY-MM-DD'),
                    createdate:"",
                    createtor:"",
                    createtorname:"",
                    password:"",
                    remarks:"",
                    accountid:"",
                    shareamount:0,
                    memberid:"",
                    tickettype:1,
                    ticketno:"",
                    orderid:"",
                },
                rules:{
                    cardnumber: [
                        {required: true, message: "请输入会员卡号", trigger: 'blur'}
                    ],
                    membername: [
                        {required: true, message: "请输入会员姓名", trigger: 'blur'}
                    ],
                    cardtypeid: [
                        {required: true, message: "请选择会员卡类型", trigger: 'blur'}
                    ],
                    /*memberphone: [
                        {required: true, message: "请输入会员手机号码", trigger: 'blur'}
                    ],*/
                    sex: [
                        {required: true, message: "请选择会员性别", trigger: 'blur'}
                    ],
                    hzstoreid: [
                        {required: true, message: "请选择合作公司", trigger: 'blur'}
                    ],
                    headstaffid:[
                        {required: true, message: "请选择负责人", trigger: 'blur'}
                    ]
                },
            }
        },
        created() {

            this.getStaffByJob();
            this.getInteboStore();
            this.getCardOperationByParam();
            this.openAddCard();
            this.getInteboMaxCardNumber();
        },
        methods:{
            getInteboMaxCardNumber(){
                this.$post("cardinfo/getInteboMaxCardNumber").then(res=>{
                    if(res.sucess){
                        let card=res.object;
                        this.addCardOperation.cardid=card.cardid;
                        this.addCardOperation.cardnumber=card.cardnumber;
                        this.addCardOperation.cardtypeid=card.cardtypeid;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            cancel(){
                this.dialogVisible = false
                this.$router.push({
                    path:"/headstaff"
                });
            },
            handleClose(done){
                this.historyBack();
            },
            changeQuery(){
                this.queryCardOperation=[];
                this.ismore=true;
                this.curpage=1;
                this.getCardOperationByParam();
            },
            openAddCard(){
                if (this.$refs["form"]) {
                    this.$refs["form"].resetFields();
                }
                this.addCardOperation=this.$copy(this.cardoperation);
                this.dialogVisible=true;
            },
            getCardOperationByParam(){
                if(this.ismore==false){
                    return;
                }
                this.$post("cardinfo/getCardOperationByParam",{storeid:this.storeid,sysbillid:"",cardnumber:this.param.cardnumber,
                accountdate:this.param.accountdate,billtype:1,isback:0,curpage:this.curpage,pagesize:20}).then(res=>{
                    if(res.sucess){
                        let obj=res.object.cardOperations;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.queryCardOperation.push(val);
                            }
                        }
                        else{
                            this.ismore=false;
                        }
                        this.curpage++;
                    }
                    else{
                        this.ismore=false;
                        this.$message.error(res.message);
                    }
                });
            },
            saveOpenCard(){
                this.$refs["form"].validate((valid) => {
                        if (valid) {
                            this.$post("cardinfo/getInteboMaxCardNumber").then(res=>{
                                if(res.sucess){
                                    this.addCardOperation.cardid=res.object.cardid;
                                    this.addCardOperation.cardnumber=res.object.cardnumber;
                                    this.addCardOperation.cardtypeid=res.object.cardtypeid;
                                    this.queryLoadBtton=true;
                                    let cardOperationVo = new Object();
                                    this.addCardOperation.storeid=this.storeid;
                                    cardOperationVo.cardOperation = this.addCardOperation;
                                    this.$postw('cardinfo/saveOpenCard',cardOperationVo).then(res=>{
                                        this.queryLoadBtton=false;
                                        if(res.sucess){
                                            this.$dialog.confirm({
                                                title:"提示",
                                                message:"开卡成功,是否需要购买疗程",
                                            }).then((action, done)=>{
                                                if (action === 'confirm') {
                                                    this.$router.push({
                                                        path:"/buycardcourse",
                                                        query:{
                                                            cardnumber:this.addCardOperation.cardnumber
                                                        }
                                                    });
                                                }
                                                else{
                                                    this.$router.push({
                                                        path:"/headstaff"
                                                    });
                                                }
                                            });
                                            this.$message({message: '开卡成功', type: 'success'});
                                            this.dialogVisible=false;
                                            this.curpage=1;
                                            this.ismore=true;
                                            this.queryCardOperation=[];
                                            this.getCardOperationByParam();
                                        }
                                        else{
                                            this.$message.error(res.$message);
                                        }
                                    });
                                }
                                else{
                                    this.$message.error(res.$message);
                                }
                        });
                    }
                        
                    });
                    
            },
            getCardInfoByCardNumberUnsold(){
                if(this.addCardOperation.cardnumber=="") {
                    return;
                }
                this.queryLoadBtton=true;
                this.$post("cardinfo/getCardInfoByCardNumberUnsold",{storeid:this.storeid,cardnumber:this.addCardOperation.cardnumber}).then(res=>{
                    this.queryLoadBtton=false;
                    if(res.sucess){
                        if (res.object == null) {
                             //先保存会员卡信息
                             let cardinfo=new Object();
                            cardinfo.createtor = localStorage.getItem("staffid");
                            cardinfo.createtorname = localStorage.getItem("staffname");
                            cardinfo.storeid = this.storeid;
                            cardinfo.cardnumber=this.addCardOperation.cardnumber;
                            cardinfo.cardtypeid="f24740c985fb473e8a6908c0317f8545";
                            this.$postw("cardinfo/saveCardInfo",cardinfo).then(res=>{
                                this.queryLoadBtton=false;
                                if(res.sucess){
                                    this.addCardOperation.cardid=res.object.cardid;
                                }
                                else{
                                    this.$message.error(res.$message);
                                }
                            });
                        }
                        else{
                            this.addCardOperation.cardid=res.object.cardid;
                        }
                    }
                    else{
                        this.queryLoadBtton=false;
                        this.addCardOperation.cardnumber="";
                        this.$message.error(res.$message);
                    }
                });
            },
            getInteboStore(){
                this.$post("inteboStore/getInteboStaffHeadStore",{staffid:localStorage.getItem("staffid")}).then(res=>{
                    if(res.sucess){
                        this.stores=res.object;
                    }
                    else{
                        this.$message.error(res.$message);
                    }
                });
            },
            getStaffByJob() {
                this.$post("inteboStaff/getStaffByInteboHasBill",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                        this.staffInfos=res.object;
                    }
                    else{
                        this.$message.error(res.$message);
                    }
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/intebo/opencard.vue